import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./App.css";
import Navbar from "./components/layout/Navbar";
import Home from "./components/pages/Home";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import About from "./components/pages/About";
import ReactGA from "react-ga";
import { Disclaimer } from "./components/pages/Disclaimer";
import { Termcon } from "./components/pages/Termcon";
import { Privacypolicy } from "./components/pages/Privacypolicy";
import { Topbar } from "./components/layout/Topbar";

function App() {
  useEffect(() => {
    ReactGA.initialize("UA-171358682-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div className="App">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Trick Piece</title>
        <meta name="description" content="TrickPiece || Learn With Us " />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="keywords"
          content="trick piece trickpiece free freecourse freecourses udemy learn course tech video youtube lecture online course "
        />
        <link
          href="https://fonts.googleapis.com/css2?family=MuseoModerno:wght@531&display=swap"
          rel="stylesheet"
        ></link>
        <link
          href="https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap"
          rel="stylesheet"
        ></link>
        <link
          href="https://fonts.googleapis.com/css2?family=Piedra&display=swap"
          rel="stylesheet"
        ></link>
      </Helmet>
      <Router>
        <Navbar />

        <Switch>
          <Route exact path="/" component={Home}></Route>
          <Route exact path="/about" component={About}></Route>
          <Route exact path="/disclaimer" component={Disclaimer}></Route>
          <Route exact path="/terms&conditions" component={Termcon}></Route>
          <Route exact path="/privacypolicy" component={Privacypolicy}></Route>
        </Switch>
        <Topbar />
      </Router>
    </div>
  );
}

export default App;
